/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NotificationType = {
    Web: 1,
    Email: 2,
    Push: 4,
    WebEmail: 3,
    WebPush: 5,
    EmailPush: 6,
    All: 7
} as const;
export type NotificationType = typeof NotificationType[keyof typeof NotificationType];

